
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hosted-payment-pages",
      function () {
        return require("private-next-pages/hosted-payment-pages/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hosted-payment-pages"])
      });
    }
  